import axios from 'axios';
import store from '../store';
import router from '../routes/router';
import Vue from "vue";

export default function setup() {
    axios.interceptors.request.use(function(config) {
        //const token = store.getters.Token;
        let token = localStorage.getItem(Vue.Keys.TOKEN);
        if(token) {
            config.headers.common["x-access-token"] = token;
        }
        return config;
    }, function(err) {
        return Promise.reject(err);
    });

    axios.interceptors.response.use(function (response) {
        return response
    }, function (error) {
        if (error.response.status === 401 || error.response.status === 403) {
            //console.log("currentRoute = ", router.currentRoute);
            let redirect = '/home';
            if(router.currentRoute.path != '/login'){
                redirect = router.currentRoute.path;
            }else{
                redirect = router.currentRoute.query.redirect || '/home';
            }
            router.push({ path: '/login', query: { redirect: redirect || '/home' } })
        }
        return Promise.reject(error);
    })
}